export const CONVERSATION_ATTACHMENTS_PATH_NAME = 'conversation-attachments';

export const SESSION_ATTACHMENT_MAX_FILES = 5;
export const SESSION_ATTACHMENT_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024;
export const SESSION_ATTACHMENT_MAX_IMAGE_FILE_SIZE_BYTES = 5 * 1024 * 1024;

export const SESSION_ATTACHMENT_ACCEPT = '.pdf,.docx,.xml,.csv';

export const SESSION_ATTACHMENT_IMAGE_MIME_TYPES = new Set<string>([
  'image/png',
  'image/jpeg',
  'image/webp',
]);

export const SESSION_ATTACHMENT_IMAGE_EXTENSIONS = new Set<string>([
  'png',
  'jpg',
  'jpeg',
  'webp',
]);

export const isConversationAttachmentImageFile = (file: {
  type: string;
  name: string;
}): boolean => {
  if (file.type && SESSION_ATTACHMENT_IMAGE_MIME_TYPES.has(file.type)) {
    return true;
  }
  const extension = file.name.split('.').pop()?.toLowerCase();
  return (
    extension !== undefined &&
    SESSION_ATTACHMENT_IMAGE_EXTENSIONS.has(extension)
  );
};

export const SESSION_ATTACHMENT_ALLOWED_MIME_TYPES = new Set<string>([
  'application/pdf',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/xml',
  'text/xml',
  'text/csv',
  'application/csv',
  ...SESSION_ATTACHMENT_IMAGE_MIME_TYPES,
]);

export const SESSION_ATTACHMENT_ALLOWED_EXTENSIONS = new Set<string>([
  'pdf',
  'docx',
  'xml',
  'csv',
  ...SESSION_ATTACHMENT_IMAGE_EXTENSIONS,
]);

export const isAllowedConversationAttachmentFile = (file: {
  type: string;
  name: string;
}): boolean => {
  if (file.type && SESSION_ATTACHMENT_ALLOWED_MIME_TYPES.has(file.type)) {
    return true;
  }
  const extension = file.name.split('.').pop()?.toLowerCase();
  return (
    extension !== undefined &&
    SESSION_ATTACHMENT_ALLOWED_EXTENSIONS.has(extension)
  );
};
